export enum PauseContextCollectionDurations {
  FiveMinutes = 5,
  FifteenMinutes = 15,
  ThirtyMinutes = 30,
  OneHour = 60,
}

export enum CONTEXT_COLLECTOR_STATE {
  UNSUPPORTED = 'UNSUPPORTED',
  PAUSED_TIMED = 'PAUSED_TIMED',
  STOPPED = 'STOPPED',
  ENABLED = 'ENABLED',
  ACCESSIBILITY_PERMISSION_MISSING = 'ACCESSIBILITY_PERMISSION_MISSING',
  STARTING = 'STARTING',
  STOPPING = 'STOPPING',
  SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
  UNABLE_TO_START = 'UNABLE_TO_START',
  UNABLE_TO_STOP = 'UNABLE_TO_STOP',
}
